import { partnersService } from "../../../service/partnersService";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import BSpinner from "../../../components/spinners/BSpinner";
import PartnersForm from "../../../forms/PartnersForm";

export default function PartnersEditPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [responseErrors, setResponseError] = useState();
  const { id } = useParams();
  const [partner, setPartner] = useState(null);
  const history = useHistory();

  useEffect(() => {
    setIsLoading(true);
    setResponseError([]);

    partnersService
      .getPartnerById(id)
      .then((res) => setPartner(res.data))
      .catch((err) => {
        if (err.response.data) {
          setResponseError(err.response.data);
        }
      })
      .finally(() => setIsLoading(false));
  }, [id]);

  const handleSubmit = (data) => {
    setIsLoading(true);
    setResponseError([]);

    data.price = data.price != null ? parseFloat(data.price) : null;
    partnersService
      .updatePartner(id, data)
      .then(() => {
        history.push(`/partners/${id}`);
      })
      .catch((err) => {
        setResponseError(err.response.data);
      })
      .finally(() => setIsLoading(false));
  };

  const deleteNull = (obj) => {
    Object.keys(obj).forEach(function (key) {
      if (obj[key] === null) {
        obj[key] = "";
      }
      return obj;
    });
    return obj;
  };

  if (isLoading) {
    return <BSpinner />;
  }

  return (
    <div className="m-6 bg-white border-gray-400 rounded shadow-md">
      {partner && (
        <>
          <PartnersForm
            onSubmit={handleSubmit}
            preloadedData={deleteNull(partner)}
            btnText="Speichern"
            responseErrors={responseErrors}
          />
        </>
      )}
    </div>
  );
}
